import './SkeletonChat.css';
import { SkeletonMessage } from './Skeleton';

export type SkeletonChatProps = {
    messages?: number;
    className?: string;
};

export function SkeletonChat({ messages = 5, className = '' }: SkeletonChatProps) {
    return (
        <div
            className={`skeleton-chat ${className}`}
            role="status"
            aria-busy="true"
            aria-label="Loading conversation"
        >
            {Array.from({ length: messages }, (_, i) => (
                <SkeletonMessage key={i} align={i % 2 === 0 ? 'left' : 'right'} />
            ))}
        </div>
    );
}
